const toBoolean = require('./util/toBoolean');

const isClient = typeof window !== 'undefined';

const config = {
  availableLanguages: ['en', 'es'],
  defaultLanguage: 'en',
  production: process.env.NODE_ENV === 'production',
  development: process.env.NODE_ENV === 'development',
  sendEmailOnDev: toBoolean(process.env.SEND_EMAIL_ON_DEV, false),
  // Dev against prod Atlas: skip leader election + audit trail change streams by default
  disableLeaderServices: toBoolean(
    process.env.DISABLE_LEADER_SERVICES,
    process.env.NODE_ENV === 'development',
  ),
  // Person.watch floods the pool when dev listens to prod people collection updates
  enablePersonWatch: toBoolean(
    process.env.ENABLE_PERSON_WATCH,
    process.env.NODE_ENV === 'production',
  ),
  mongoURL:
    process.env.MONGO_URL ||
    process.env.MONGODB_URI ||
    'mongodb://localhost:27017/mern-starter?socketTimeoutMS=90000',
  mongoURLOld:
    process.env.MONGO_URL_OLD ||
    process.env.MONGODB_URI_OLD ||
    process.env.MONGO_URL ||
    process.env.MONGODB_URI ||
    'mongodb://localhost:27017/mern-starter?socketTimeoutMS=90000',
  elasticURL: process.env.ELASTIC_URL || process.env.SEARCHBOX_URL || 'http://localhost:9200',
  elasticIndex: process.env.ELASTIC_INDEX || 'responses_alias',
  publicPort: Number(process.env.SERVER_PUBLIC_PORT) || 443,
  port: Number(process.env.PORT) || 443,
  protocol: (Number(process.env.SERVER_PUBLIC_PORT) || 443) === 443 ? 'https' : 'http',
  address: process.env.SERVER_ADDRESS || 'www.promoter.ninja',
  shortenerAddress: process.env.SHORTENER_SERVER_ADDRESS || 't.ptnj.io',
  sendGridApiKey: process.env.SENDGRID_API_KEY,
  sendGridDefaultDomain: process.env.SENDGRID_DEFAULT_DOMAIN || 'em.promoter.ninja',
  sendGridVerificationKey: process.env.SENDGRID_VERIFICATION_KEY,
  mailGunApiKey: process.env.MAILGUN_API_KEY,
  mailGunDefaultDomain: process.env.MAILGUN_DEFAULT_DOMAIN || 's.promoter.ninja',
  sesDefaultDomain: process.env.SES_DEFAULT_DOMAIN || 'email.m.promoter.ninja',
  sesArn:
    process.env.SES_SOURCE_ARN || 'arn:aws:ses:eu-west-1:199186692721:identity/m.promoter.ninja',
  mailServiceType: process.env.MAIL_SERVICE_TYPE || 'SENDGRID',
  mailGunApiHost: process.env.MAILGUN_API_HOST || '',
  stripeSecretKey: process.env.STRIPE_SECRET_KEY,
  stripeWebhookSecret: process.env.STRIPE_WEBHOOK_SECRET,
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
  // Tag used to scope Stripe products/prices to Promoter Ninja on the shared account
  stripeAppTag: process.env.STRIPE_APP_TAG || 'promoter-ninja',
  googleOauthClientId: process.env.GOOGLE_OAUTH_CLIENT_ID,
  slack: {
    clientId: process.env.SLACK_CLIENT_ID,
    clientSecret: process.env.SLACK_CLIENT_SECRET,
  },
  gsheets: {
    clientId: process.env.GOOGLE_OAUTH_CLIENT_ID,
    clientSecret: process.env.GOOGLE_OAUTH_CLIENT_SECRET,
  },
  hubspot: {
    clientId: process.env.HUBSPOT_CLIENT_ID,
    clientSecret: process.env.HUBSPOT_CLIENT_SECRET,
    developerApiKey: process.env.HUBSPOT_DEVELOPER_API_KEY,
  },
  zendesk: {
    clientId: process.env.ZENDESK_CLIENT_ID,
    clientSecret: process.env.ZENDESK_CLIENT_SECRET,
  },
  salesforce: {
    clientId: process.env.SALESFORCE_CLIENT_ID,
    clientSecret: process.env.SALESFORCE_CLIENT_SECRET,
  },
  aws: {
    S3_LOGOS_BUCKET: 'l.promoter.ninja',
    S3_IMPORTS_BUCKET: 'import.promoter.ninja',
    S3_EXPORTS_BUCKET: 'exports.promoter.ninja',
    S3_INVOICES_BUCKET: process.env.S3_INVOICES_BUCKET || 'invoices.promoter.ninja',
  },
  sageActive: {
    clientId: process.env.SAGEACTIVE_CLIENT_ID,
    clientSecret: process.env.SAGEACTIVE_SECRET,
    subscriptionKey: process.env.SAGEACTIVE_SUBSCRIPTION_KEY,
    callbackUrl: process.env.SAGEACTIVE_CALLBACK_URL,
    authUrl: process.env.SAGEACTIVE_AUTH_URL || 'https://sbcauth.sage.fr/connect/authorize',
    tokenUrl: process.env.SAGEACTIVE_TOKEN_URL || 'https://sbcauth.sage.fr/connect/token',
    baseUrl: process.env.SAGEACTIVE_BASE_URL || 'https://api.es.active.sage.com',
    tenantId: process.env.SAGEACTIVE_TENANT_ID,
    organizationId: process.env.SAGEACTIVE_ORGANIZATION_ID,
    journalTypeId: process.env.SAGEACTIVE_JOURNAL_TYPE_ID || '16ceb06e-13b7-4360-9423-fe91eb329216',
    paymentMethodId:
      process.env.SAGEACTIVE_PAYMENT_METHOD_ID || '19cde8b4-69e8-4eb6-a75b-4710b28af08b',
    operationalNumberPresetTextId:
      process.env.SAGEACTIVE_OPERATIONAL_NUMBER_PRESET_ID || '19cde8b4-8479-4eb6-a75b-4710b28af08b',
    subscriptionProductCode: process.env.SAGEACTIVE_SUBSCRIPTION_PRODUCT_CODE || 'PROMOTERNINJA',
    productCode: process.env.SAGEACTIVE_PRODUCT_CODE || 'PROMOTERNINJA',
    tokenRefreshBufferMs: Number(process.env.SAGEACTIVE_TOKEN_REFRESH_BUFFER_MS) || 5 * 60 * 1000,
    adminAlertEmail: process.env.SAGEACTIVE_ADMIN_ALERT_EMAIL,
    verifactuTestMode: process.env.SAGEACTIVE_VERIFACTU_TEST_MODE === 'true',
    /** Invoices on or after this date include the Verifactu QR block. */
    verifactuActivationDate: process.env.SAGEACTIVE_VERIFACTU_ACTIVATION_DATE || '2026-06-14',
    invoiceIssuer: {
      name: process.env.SAGEACTIVE_ISSUER_NAME || 'HoshinPlan Strategy S.L.',
      nif: process.env.SAGEACTIVE_ISSUER_NIF || 'B66985110',
      email: process.env.SAGEACTIVE_ISSUER_EMAIL || 'billing@promoter.ninja',
      addressLines: [
        process.env.SAGEACTIVE_ISSUER_ADDRESS_LINE1 || 'Sant Francesc, 4',
        process.env.SAGEACTIVE_ISSUER_ADDRESS_LINE2 || '08290 Cerdanyola del Vallès, Barcelona',
      ].filter(Boolean),
      iban: process.env.SAGEACTIVE_ISSUER_IBAN || 'ES69 0081 0056 9600 0229 2137',
      bankName:
        process.env.SAGEACTIVE_ISSUER_BANK || '(SWIFT/BIC: BSABESBB) BANCO DE SABADELL, S.A.',
    },
  },
  imagesHost: 'l.promoter.ninja',
  logoHost: 'i.promoter.ninja',
  defaultEmailProps: {
    from: {
      name: 'Promoter Ninja',
      email: 'hello@promoter.ninja',
    },
    subject: ' ',
    html: ' ',
  },
  defaultMinSurveyInterval: '6 month',
  sentryDsn: process.env.SENTRY_DSN,
  sentryPublicDsn: process.env.SENTRY_PUBLIC_DSN,
  maxFileSize: 5000, // In kb
  cid: process.env.CID,
  messenteApiUsername: process.env.MESSENTE_API_USERNAME,
  messenteApiPassword: process.env.MESSENTE_API_PASSWORD,
  sendSMS: toBoolean(process.env.SEND_SMS, true),
  intercomSecret: process.env.INTERCOM_SECRET,
  demoTime: process.env.DEMO_TIME,
  demoTime2: isClient ? process.env.REACT_APP_DEMO_TIME : process.env.DEMO_TIME,
  msTranslateAPIKey: process.env.MS_TRANSLATE_API_KEY,
  tokenMaxAge: '30m',
  sessionLength: '15d',
  signedURLSecret: process.env.SIGNED_URL_SECRET,
  defaultSampling: 1.0,
  minAdaptiveSamplingSurveys: 5,
  assetsRootUrl: process.env.NODE_ENV === 'production' ? 'https://cdn.promoter.ninja/' : '/static/',
  translationService: process.env.TRANSLATION_SERVICE || 'aws',
  configFilesDir: process.env.CONFIG_FILES_DIR,
  maxMindAccountID: process.env.MAXMIND_ACCOUNT_ID,
  maxMindLicenseKey: process.env.MAXMIND_LICENSE_KEY,
  sessionPepper: process.env.SESSION_PEPPER,
};
const urlPort = [80, 443].indexOf(config.publicPort) >= 0 ? '' : `:${config.publicPort}`;
config.rootUrl = `${config.protocol}://${config.address}${urlPort}`;
config.shortRootUrl = `${config.protocol}://${config.shortenerAddress}${urlPort}`;
config.apiUrl =
  typeof window === 'undefined' || process.env.NODE_ENV === 'test'
    ? process.env.BASE_URL || `${config.rootUrl}/api`
    : '/api';
config.serverSideRendering =
  typeof process.env.SSR === 'undefined' ? config.production : toBoolean(process.env.SSR);
config.ReCaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY;
config.ReCaptchaSecretKey = process.env.RECAPTCHA_SECRET_KEY;
config.SalesForceManagedAppVersion = process.env.SALESFORCE_MANAGED_APP_VERSION;
module.exports = config;
